export const defaultSocialShare = [
  {
    link: {
      title: 'Email',
      href: 'mailto:?body=%url%',
    },
  },
  {
    link: {
      title: 'Facebook',
      href: 'https://www.facebook.com/sharer/sharer.php?u=%url%',
    },
  },
  {
    link: {
      title: 'Pinterest',
      href: 'https://pinterest.com/pin/create/button/?url=%url%',
    },
  },
]
